// extracted by mini-css-extract-plugin
export var active = "_54-a";
export var activeIndicator = "_54-9";
export var disabled = "_54-b";
export var fullWidth = "_54-2";
export var lg = "_54-7";
export var md = "_54-6";
export var redoButtonTabGroup = "_54-0";
export var sm = "_54-5";
export var tabButton = "_54-4";
export var tabButtonsContainer = "_54-1";
export var themeDestructive = "_54-d";
export var themeNormal = "_54-c";
export var themeSuccess = "_54-e";
export var xl = "_54-8";
export var xs = "_54-3";